import { LETTER_SPACING_UNITS } from "../../constants";
import { createNumberInputGuards } from "../../helpers/numberInput";

const { sanitise, toCssNumber } = createNumberInputGuards({ allowNegative: true });

const readCurrent = editor => {
  const styled = editor.dom.getParent(editor.selection.getNode(), node => node.style && node.style.letterSpacing);
  const parsed = styled ? /^(-?\d*\.?\d+)(px|em)$/.exec(styled.style.letterSpacing) : null;

  if (!parsed) {
    return { spacing: "", unit: "px" };
  }

  return { spacing: parsed[1], unit: parsed[2] };
};

const openLetterSpacingDialog = editor => {
  editor.windowManager.open({
    title: "Letter spacing",
    body: {
      type: "panel",
      items: [
        {
          type: "input",
          name: "spacing",
          label: "Spacing (negative tightens)",
        },
        {
          type: "listbox",
          name: "unit",
          label: "Unit",
          items: LETTER_SPACING_UNITS,
        },
      ],
    },
    initialData: readCurrent(editor),
    buttons: [
      {
        type: "custom",
        name: "removeButton",
        text: "Remove",
        align: "start",
      },
      {
        type: "cancel",
        name: "closeButton",
        text: "Cancel",
      },
      {
        type: "submit",
        name: "submitButton",
        text: "Apply",
        primary: true,
      },
    ],
    onChange: function (api) {
      const { spacing } = api.getData();
      const sanitised = sanitise(spacing);

      if (sanitised !== spacing) {
        api.setData({ spacing: sanitised });
      }
    },
    onAction: function (api, details) {
      if (details.name === "removeButton") {
        editor.formatter.remove("letterspacing");
        api.close();
      }
    },
    onSubmit: function (api) {
      const { spacing, unit } = api.getData();
      // Re-validated here because pasting bypasses the per-keystroke filter
      const value = toCssNumber(spacing);

      if (value === "") {
        editor.formatter.remove("letterspacing");
      } else {
        editor.formatter.apply("letterspacing", { value: `${value}${unit}` });
      }

      api.close();
    },
  });
};

export { openLetterSpacingDialog };
